import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({ selector: '[appStickyHeader]' })
export class StickyHeaderDirective implements AfterViewInit, OnDestroy {
    private fullHeader: HTMLElement;
    private header: HTMLElement;
    private initialMarginBottom: number;
    private replyContainer: HTMLElement;
    private scrollArea: HTMLElement;

    constructor(private element: ElementRef) {
        this.toggleSticky = this.toggleSticky.bind(this);
    }

    ngAfterViewInit(): void {
        this.scrollArea = document.getElementById('ticket-details-container-for-scroll');
        this.fullHeader = this.scrollArea.querySelector('.ticket-header');
        this.header = this.element.nativeElement;
        this.initialMarginBottom = Number(window.getComputedStyle(this.fullHeader).marginBottom.slice(0, -2));

        this.scrollArea.addEventListener('scroll', this.toggleSticky);
    }

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    toggleSticky(): void {
        let scrollEdge: number;
        if (!this.header.classList.contains('sticky')) {
            scrollEdge = this.header.offsetTop;
        } else {
            scrollEdge =
                this.fullHeader.clientHeight -
                Number(window.getComputedStyle(this.fullHeader).paddingBottom.slice(0, -2));
        }

        if (this.scrollArea.scrollTop > scrollEdge) {
            if (!this.header.classList.contains('sticky')) {
                this.fullHeader.style.marginBottom = this.initialMarginBottom + this.header.clientHeight + 'px';
                this.fullHeader.classList.add('position-static');
                this.header.classList.add('sticky');
            }
            this.updateStickyReplyContainer();
        } else if (this.scrollArea.scrollTop < scrollEdge) {
            if (this.header.classList.contains('sticky')) {
                this.fullHeader.style.marginBottom = this.initialMarginBottom + 'px';
                this.fullHeader.classList.remove('position-static');
                this.header.classList.remove('sticky');
            }
        }
    }

    private updateStickyReplyContainer(): void {
        if (!this.replyContainer) {
            this.replyContainer = document.getElementById('reply-editor-container');
            if (!this.replyContainer) {
                return;
            }
        }
        if (this.replyContainer.classList.contains('sticky') && this.replyContainer.classList.contains('order-1')) {
            const short = document.getElementById('ticket-short-header');
            this.replyContainer.style.setProperty('--sticky-reply-top', short.clientHeight + 20 + 'px');
        }
    }

    ngOnDestroy(): void {
        if (this.scrollArea) {
            this.scrollArea.removeEventListener('scroll', this.toggleSticky);
        }
    }
}
